// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__11HQl","row":"styles_row__xhlLL"};